import { render, staticRenderFns } from "./CreateFormationCouncils.vue?vue&type=template&id=9ae713d0&scoped=true&"
import script from "./CreateFormationCouncils.vue?vue&type=script&lang=js&"
export * from "./CreateFormationCouncils.vue?vue&type=script&lang=js&"
import style0 from "./CreateFormationCouncils.vue?vue&type=style&index=0&id=9ae713d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae713d0",
  null
  
)

export default component.exports